module.exports = __webpack_public_path__ + "./chels_9416b4ab58e4973c02a7021d1f6eb7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/chels.png
// module id = 443
// module chunks = 0